import { Button, Group, Select, Stack, TextInput } from '@mantine/core';
import DateField from 'components/DateField';
import Modal from 'components/ModalPopup';
import React, { useState } from 'react';

interface SchoolParams {
  search?: string;
  status?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  page?: number;
  size?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

interface ModalFilterSchoolManagementProps {
  opened: boolean;
  onClose: () => void;
  onFilter?: (_params: SchoolParams) => void;
  defaultValue?: SchoolParams;
}

const ModalFilterSchoolManagement: React.FC<ModalFilterSchoolManagementProps> = ({
  onClose,
  opened,
  onFilter,
  defaultValue
}) => {
  const [search, setSearch] = useState<string>(defaultValue?.search || '');
  const [status, setStatus] = useState<string | null>(defaultValue?.status || null);
  const [startDate, setStartDate] = useState<Date | null>(defaultValue?.startDate || null);
  const [endDate, setEndDate] = useState<Date | null>(defaultValue?.endDate || null);

  const handleFilter = () => {
    if (onFilter) {
      onFilter({
        search,
        status,
        startDate,
        endDate
      });
    }
  };

  const handleReset = () => {
    setSearch('');
    setStatus(null);
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <Modal close={onClose} opened={opened} title='Filter School Management'>
      <Stack>
        <TextInput
          label='Search'
          placeholder='Search by school name'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Select
          label='Status'
          placeholder='Select status'
          value={status}
          onChange={setStatus}
          data={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' }
          ]}
          clearable
        />
        <DateField
          label='Start Date'
          placeholder='Select start date'
          value={startDate}
          onChange={setStartDate}
          clearable
        />
        <DateField
          label='End Date'
          placeholder='Select end date'
          value={endDate}
          onChange={setEndDate}
          clearable
        />
        <Group justify='space-between'>
          <Button variant='subtle' onClick={onClose}>
            Cancel
          </Button>
          <Group justify='flex-end' mt='md'>
            <Button variant='outline' onClick={handleReset}>
              Reset
            </Button>
            <Button onClick={handleFilter}>Apply Filter</Button>
          </Group>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalFilterSchoolManagement;
